/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ListPage } from './types';

const yApiObj = {
  // yapi: 1263
};

enum Api {
  listPage = '/front-end/ht/contract/list', // 合同列表
  getContractDetail = '/front-end/ht/contract/info', // 获取合同详情
  downloadContract = '/front-end/ht/contract/download',
  getParticipatantList = '/back-end/ht/type/participants', // 获取可选的参与方列表
  getContractTypeApi = '/front-end/ht/contract/contractType',
  applyForQuiesceApi = '/front-end/ht/contract/applyForQuiesce', // 合同-申请静默签约
  queryQuiesceApi = '/front-end/ht/contract/queryQuiesce',
  getEnterpriseList = '/back-end/ht/type/participants/entpList', // 企业关联公司-获取企业列表
  getContractUserInfoApi = '/front-end/ht/contract/contractList/userInfo',
  getParticipatantOpt = '/front-end/ht/contract/type/participants' // 列表-参与方选项
}

/**
 * 合同列表
 */
export const listPage: ListPage = params =>
  http.request(
    {
      url: Api.listPage,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );

/** 获取合同详情 */
export const getContractDetail = async params => {
  return await http.request(
    {
      url: Api.getContractDetail,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};
/**
 * 合同下载
 */
export const downloadContract = async params =>
  http.download({
    url: Api.downloadContract,
    method: 'POST',
    params
  });

/**
 * 获取可选的参与方列表
 */
export const getPartOptList = async params => {
  const { data } = await http.request(
    {
      url: Api.getParticipatantList,
      method: 'POST',
      params: { ...params, source: 2, port: 1 }
    },
    {
      // yapi: 1271
    }
  );
  return data;
};

/** 合同-获取当前登录者的合同类型 */
export const getContractType = async params => {
  const { data } = await http.request(
    {
      url: Api.getContractTypeApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-申请静默签约 */
export const applyForQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.applyForQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-获取登录的企业，是否开启静默签约 */
export const queryQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.queryQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/**
 * 获取签署主体对应的企业列表
 */
export const getEnterpriseList = async (params: {
  participantValue?: string; // 企业类型 1-工业 2-服务商
  entpName?: string; // 企业名称
  type: number; // 类型
  source: number;
  entpId?: number;
  contractType: number;
}) => {
  const res = await http.request(
    {
      url: Api.getEnterpriseList,
      method: 'POST',
      params: { ...params, pageNum: 1, pageSize: 100 }
    },
    {
      ...yApiObj
    }
  );
  let selectedEntp = [];
  if (params.entpId) {
    if (!res.data?.list.some(item => item.id === params.entpId)) {
      selectedEntp = [
        {
          id: params.entpId,
          name: params.entpName
        }
      ];
    }
  }
  return {
    ...res,
    data: {
      ...res.data,
      list: [
        ...selectedEntp,
        ...res.data?.list?.map(item => ({
          ...item,
          name: `${item.name}${item.phone ? `(${item.phone?.slice(-4)})` : ''}`
        }))
      ]
    }
  };
};

/** 合同管理-列表-企业信息/个人信息 */
export const getContractUserInfo = async params => {
  return await http.request(
    {
      url: Api.getContractUserInfoApi,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/** 合同管理-列表-签署方下拉选项 */
export const getParticipatantOpt = async params => {
  return await http.request(
    {
      url: Api.getParticipatantOpt,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};
